import { render, staticRenderFns } from "./AnnotationAddDialog.vue?vue&type=template&id=1a3c9edb&scoped=true&"
import script from "./AnnotationAddDialog.vue?vue&type=script&lang=js&"
export * from "./AnnotationAddDialog.vue?vue&type=script&lang=js&"
import style0 from "./AnnotationAddDialog.vue?vue&type=style&index=0&id=1a3c9edb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3c9edb",
  null
  
)

export default component.exports